module.exports = __webpack_public_path__ + "img/logo.6dcd37c6.png";